var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    class: "main-view ".concat(_vm.mainViewExpand && 'expand'),
    style: _vm.globalCssVar
  }, [_c('div', {
    staticClass: "container-scroller"
  }, [_c('app-header', {
    attrs: {
      "isMobile": _vm.isMobile,
      "themeConfig": _vm.themeConfig
    }
  }), _c('div', {
    staticClass: "container-fluid page-body-wrapper"
  }, [_vm.isMobile ? _c('b-sidebar', {
    staticClass: "app-sidebar",
    attrs: {
      "id": "sidebar-backdrop",
      "backdrop": "",
      "shadow": "",
      "width": "270px"
    }
  }, [_c('app-sidebar', {
    attrs: {
      "themeConfig": _vm.themeConfig
    },
    on: {
      "updateView": _vm.updateView
    }
  })], 1) : _c('app-sidebar', {
    attrs: {
      "themeConfig": _vm.themeConfig
    },
    on: {
      "updateView": _vm.updateView
    }
  }), _c('div', {
    staticClass: "main-panel"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1), _vm.footerText ? _c('app-footer', {
    attrs: {
      "footer-text": _vm.footerText
    }
  }) : _vm._e()], 1)], 1)], 1), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showBackToTop,
      expression: "showBackToTop"
    }],
    staticClass: "back-to-top",
    attrs: {
      "aria-label": "Back to top"
    },
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('span', {
    staticClass: "mdi mdi-chevron-up mdi-36px"
  })]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showMoveToBottom,
      expression: "showMoveToBottom"
    }],
    staticClass: "move-to-bottom",
    attrs: {
      "aria-label": "Move to bottom"
    },
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_c('span', {
    staticClass: "mdi mdi-chevron-down mdi-36px"
  })]), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v(_vm._s(_vm.dashboardScript))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }